export default {
  generalInformation: {
    notes: 'Header of general information section for SAM account',
    message: 'General information',
  },
  dataSharing: {
    notes: 'Header of data sharing section for SAM account',
    message: 'Data sharing',
  },
  agreement: {
    notes: 'Header of agreement section for My SAM account',
    message: 'Agreement',
  },
  model: {
    sharingDataWith: {
      notes: 'Label for field Sharing data with',
      message: 'Sharing data with',
    },
    processorOfData: {
      notes: 'Label for field Processor of data',
      message: 'Processor of data',
    },
    controllerOfData: {
      notes: 'Label for field Controller of data',
      message: 'Controller of data',
    },
    agreementStatus: {
      notes: 'Agreement status field for SAM account',
      message: 'Agreement status',
    },
    subscriptionType: {
      notes: 'Subscription type field for SAM account',
      message: 'Subscription type',
    },
    startDateForCurrentSubscription: {
      notes: 'Start date for current subscription field for SAM account',
      message: 'Start date for current subscription',
    },
    dataTransfer: {
      notes: 'Data transfer field for SAM account',
      message: 'Data transfer',
    },
  },
};
